import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

function FooterLink({ to, children, testid, external = false }) {
  const cls =
    "group flex items-center justify-between gap-2 py-2.5 text-sm text-[#D1CFC9] hover:text-[#C9A961] transition border-b border-[#C9A961]/8 last:border-b-0";
  const inner = (
    <>
      <span>{children}</span>
      <ArrowRight className="w-3.5 h-3.5 opacity-50 group-hover:opacity-100 group-hover:translate-x-0.5 transition" strokeWidth={1.8} />
    </>
  );
  if (external) {
    return (
      <a href={to} className={cls} data-testid={testid} target="_blank" rel="noopener noreferrer">
        {inner}
      </a>
    );
  }
  return (
    <Link to={to} className={cls} data-testid={testid}>
      {inner}
    </Link>
  );
}

export default function Footer() {
  return (
    <footer className="border-t border-[#C9A961]/15 bg-[#0A0908] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <div
            className="text-[#C9A961] text-2xl mb-1"
            style={{ fontFamily: "Cormorant Garamond, serif" }}
          >
            The Crown Path Initiative
          </div>
          <div className="text-[10px] uppercase tracking-[0.18em] text-[#C9A961]/80 mb-2" data-testid="footer-foundation-attribution">
            A program of The 1123 Foundation
          </div>
          <p className="text-sm text-[#8A8782] italic">
            On the path to earning our crowns.
          </p>
        </div>

        <div>
          <div className="overline mb-3">Program</div>
          <ul className="flex flex-col">
            <li><FooterLink to="/tracks" testid="footer-link-tracks">7 Structured Tracks</FooterLink></li>
            <li><FooterLink to="/about" testid="footer-link-trauma">Trauma-Informed Curriculum</FooterLink></li>
            <li><FooterLink to="/about#certification" testid="footer-link-cert">Certification Pathway</FooterLink></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-3">For Institutions</div>
          <ul className="flex flex-col">
            <li><FooterLink to="/support?tab=license" testid="footer-link-partner">Partner With Us</FooterLink></li>
            <li><FooterLink to="/support" testid="footer-link-donate">Donate</FooterLink></li>
            <li><FooterLink to="/about" testid="footer-link-mission">Our Mission</FooterLink></li>
            <li><FooterLink to="/founder" testid="footer-link-founder">Meet the Founder</FooterLink></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#C9A961]/10 py-6 text-center text-xs text-[#8A8782] px-6">
        © {new Date().getFullYear()} The Crown Path Initiative · a program of The 1123 Foundation — Take responsibility. Grow. Lead. For men &amp; young men · women &amp; young girls.
      </div>
    </footer>
  );
}
